import Table from '@/shared/Table'
import { useTranslation } from 'react-i18next'
import Checkbox from '@mui/material/Checkbox'
import FormSelect from '@/shared/FormCreator/FormItem/FormSelect'
import omit from 'lodash/omit'
import has from 'lodash/has'

const columnTranslationString = {
  email: 'email',
  phone: 'phone',
  cname: 'name',
  companyName: 'company_name',
  firstName: 'first_name',
  lastName: 'last_name',
  department: 'department',
  deptGroup: 'business_group',
  office: 'office',
  position: 'position',
  manager: 'manager',
  // joinOn: 'join_on',
}

const ColumnMapping = ({ data, setMappingData, mappingData = {}, simulateItem }) => {
  const { titleList = [], uploadTitleListl = [] } = data || {}
  const { t } = useTranslation()

  const cols = [
    { field: 'frontGap', headerName: '', flex: 1 },
    {
      field: 'check',
      headerName: '',
      width: 60,
      renderCell: ({ row }) => {
        const { mapColumn } = row

        let disabled = false

        switch (simulateItem) {
          case 'EMAIL':
            if (mapColumn === 'email') {
              disabled = true
            }
            break
          case 'PHONE':
            if (mapColumn === 'phone') {
              disabled = true
            }
            break
          case 'EMAILANDPHONE':
            if (mapColumn === 'email' || mapColumn === 'phone') {
              disabled = true
            }
            break
          default:
            break
        }

        return (
          <Checkbox
            disabled={disabled}
            checked={has(mappingData, mapColumn)}
            sx={{
              '&.Mui-checked': {
                color: theme => theme.palette.secondary_80.main,
              },
            }}
            onChange={(_, value) => {
              if (value) {
                setMappingData({ ...mappingData, [mapColumn]: '' })
              } else {
                setMappingData(omit({ ...mappingData }, mapColumn))
              }
            }}
          />
        )
      },
    },
    {
      field: 'mapColumn',
      headerName: t('general.data_column'),
      flex: 1,
      renderCell: ({ row }) => <p>{t(`general.${columnTranslationString[row.mapColumn]}`)}</p>,
    },
    {
      field: 'mapTarget',
      headerName: t('general.upload_column'),
      flex: 1,
      renderCell: ({ row }) => {
        const { mapColumn } = row

        return (
          <FormSelect
            inputConfig={{
              options: uploadTitleListl.map(title => ({ value: title, label: title })),
              disabled: !has(mappingData, mapColumn),
              inputBaseProps: {
                labelSuffix: '',
                sx: {
                  '& .MuiGrid-item': { width: '100%' },
                },
              },
              sx: { padding: 0, margin: 0, mb: 0 },
              value: mappingData[mapColumn] || '',
              onChange: e => {
                setMappingData({ ...mappingData, [mapColumn]: e.target.value })
              },
            }}
          />
        )
      },
    },
    { field: 'endGap', headerName: '', flex: 1 },
  ]

  const rows = titleList.map(title => ({ mapColumn: title }))

  return (
    <Table
      minHeight={300}
      rows={rows}
      columns={cols}
      dataGridConfig={{ components: { Pagination: () => null }, getRowId: row => row.mapColumn }}
      containerStyle={{ marginTop: '20px' }}
    />
  )
}

export default ColumnMapping
